// 占位页：业务页（src/features/<domain>/index.tsx）就绪前的统一落点。
// App.tsx 用 import.meta.glob 自动探测业务页文件——文件一旦创建即自动替换本占位，无需改路由。

import { EmptyState, PageHeader } from "@bf/ui";

export interface PlaceholderPageProps {
  /** 页面中文名（如"申报中心"） */
  name: string;
}

export function PlaceholderPage({ name }: PlaceholderPageProps) {
  return (
    <div>
      <PageHeader eyebrow="页面" title={name} description="该业务页尚未就绪" />
      <div className="mt-4 rounded-lg border border-gray-200 bg-white shadow-sm">
        <EmptyState title="页面建设中" description={`「${name}」即将上线，敬请期待`} />
      </div>
    </div>
  );
}
